module.exports = __webpack_public_path__ + "img/1.c407be62.jpg";